import toast from "react-hot-toast";
import * as api from "../Api";
import { errorMessage, loadFailed } from "../utils/errorMessage";

export const getAssetSettings = () => async (dispatch) => {
  try {
    const { data } = await api.getAssetSettings();
    dispatch({ type: "SET_ASSET_SETTINGS", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};

// Resolves true when saved
export const saveAssetSettings = (postData) => async (dispatch) => {
  const savingId = toast.loading("Saving settings...");
  try {
    const { data } = await api.updateAssetSettings(postData);
    dispatch({ type: "SET_ASSET_SETTINGS", payload: data });
    toast.remove(savingId);
    toast.success("Asset code settings saved");
    return true;
  } catch (error) {
    toast.remove(savingId);
    toast.error(errorMessage(error, "Failed to save settings"));
    return false;
  }
};
